<template>
  <div @click="$emit('widgetAdd');">
    <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-school"></v-icon>
      </v-col>

      <v-col style="word-break: break-word" class="d-flex flex-column align-center">
        <span>Классное руководство</span>
      </v-col>
  </div>
</template>

<script>
export default {
  emits: ["widgetAdd"], //обязательный для всех виджетов
  props: {
    //обязательный для всех виджетов.клик по иконке. нужно открыть доп. настройки
    //или заэмитить widgetAdd
    showWidgetSettings: {
      required: true,
    },
  },
  name: "curatorSettings",
  data() {
    return {
    };
  },
  watch: {
    
  },
  created() {
    
  },
  methods: {
  }
};
</script>
